import { useEffect, useRef, useState } from 'react';

const BACKEND_URL = window.location.origin;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const exchangeToken = async () => {
      const hash = window.location.hash || '';
      const sessionId = hash.replace('#session_id=', '');
      if (!sessionId) { setError('Código de autorização não encontrado'); return; }
      try {
        const resp = await fetch(`${BACKEND_URL}/api/auth/session?session_id=${encodeURIComponent(sessionId)}`, {
          method: 'POST',
          credentials: 'include',
        });
        let errMsg = 'Falha na autenticacao';
        if (!resp.ok) {
          try {
            const errData = await resp.json();
            errMsg = errData.detail || errMsg;
          } catch {}
          setError(errMsg);
          return;
        }
        const data = await resp.json();
        const role = data.role;
        if (role === 'auxiliar') {
          window.location.href = '/auxiliar';
        } else if (role === 'gestor') {
          window.location.href = '/gestor';
        } else if (role === 'movimentos_coordenador') {
          window.location.href = '/movimentos-painel';
        } else {
          window.location.href = '/admin';
        }
      } catch (err) {
        setError(err.message || 'Erro inesperado na autenticacao');
      }
    };
    exchangeToken();
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
        <div className="text-center max-w-md">
          <h2 className="text-xl font-bold text-red-600 mb-2">Erro na Autenticacao</h2>
          <p className="text-slate-600 mb-4">{error}</p>
          <button onClick={() => window.location.href = '/'} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
            Voltar ao Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-slate-600">Autenticando...</p>
      </div>
    </div>
  );
}
